module.exports = __webpack_public_path__ + "img/acmedback.14fb660e.png";